jarallax(document.querySelectorAll('.jarallax'), {
    disableParallax: /iPad|iPhone|iPod|Android/,
});

$('.jarallax__hero').jarallax({
    speed: 0.2
});

$('.jarallax__third__block').jarallax({
    speed: 0.1
});

$('.jarallax__fourth__block').jarallax({
    speed: 0.1,
    keepImg: true,
    imgPosition: 'center',
    imgSize: 'cover',
    threshold: 1
});

$('.jarallax__fifth__block').jarallax({
    speed: 0.1
});

$('.jarallax__seventh__block').jarallax({
    speed: 0.1
});

$('.jarallax__eighth__block').jarallax({
    speed: 0.1
});

$('.jarallax__tenth__block').jarallax({
    speed: 0.1
});

$('.jarallax__fourteenth__block').jarallax({
    speed: 0.1
});

